import React from 'react';
import Typography from '../Text/Typography';
import Icon from '../Icon/Icon';
import './Toast.css';

export type ToastVariant = 'success' | 'error' | 'info';

export interface ToastItem {
  id: string;
  message: string;
  variant: ToastVariant;
}

interface ToastProps {
  toast: ToastItem;
  onDismiss?: (id: string) => void;
}

const variantIcon: Record<ToastVariant, 'check' | 'alert' | 'info'> = {
  success: 'check',
  error: 'alert',
  info: 'info',
};

const Toast: React.FC<ToastProps> = ({ toast, onDismiss }) => {
  return (
    <div
      className={`toast toast--${toast.variant}`}
      role="status"
      aria-live="polite"
    >
      <span className="toast-icon" aria-hidden>
        <Icon
          name={variantIcon[toast.variant]}
          size="small"
          colorVariant={toast.variant === 'success' ? 'dark-green' : toast.variant === 'error' ? 'warning-red' : 'dark-gray'}
        />
      </span>
      <div className="toast-message">
        <Typography variant="body">{toast.message}</Typography>
      </div>
    </div>
  );
};

export default Toast;
